(function () {
  'use strict';

  /* @ngdoc object
   * @name payment
   * @description
   *
   */
  angular
    .module('payrollDutySummary', [
      'ui.router'
    ]);
}());
